<template lang="pug">
  form.advanced-saearch(@submit.prevent="onSubmit")
    .columns
      .column
        .field
          label.label Cerca un'azione
          .control
            input.input(type="text" placeholder="Inserisci il nome" v-model="filters.name")
        .field
          label.label Tipologia
          .control
            .select
              select(v-model="filters.type")
                option(value="" selected) Seleziona una tipologia
                option(v-for="(tipo, index) in tipologie" :key="index" :value="tipo.tipologia") {{ tipo.tipologia }}
        .field
          label.label Fase
          .control
            .select
              select(v-model="filters.phase")
                option(value="" selected) Seleziona una fase
                option(v-for="(fase, index) in fasi" :key="index" :value="fase.name") {{ fase.name }}
      .column
        .field
          label.label Intervento
          .control
            .select
              select(v-model="filters.intervention")
                option(value="" selected) Seleziona un intervento
                option(v-for="(value, index) in interventi" :key="index" :value="value.intervento") {{ value.intervento }}
        .field
          label.label PDS di identificazione
          .control
            .select
              select(v-model="filters.pds")
                option(value="" selected) Seleziona un PDS
                option(v-for="(value, index) in pds" :key="index" :value="value.PDS") {{ value.PDS }}
        .field
          label.label Regione
          .control
            .select
              select(v-model="filters.region")
                option(value="" selected) Seleziona una regione
                option(v-for="(regione, index) in regioni" :key="index" :value="regione.nome") {{ regione.nome }}
    .field.is-grouped.is-grouped-right.actions
      .control
        button.button.is-text(type="button" @click="cancel") Cancella
      .control
        button.button.is-next(type="submit" v-if="checkForm()")
          | Cerca
          span →
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'AdvancedSaearch',
  computed: {
    ...mapGetters([
      'regioni',
      'tipologie',
      'pds',
      'interventi',
      'config'
    ]),
    fasi: function () {
      // const config = this.$store.getters.config
      // return config.fasi
      return this.config.fasi
    }
  },
  data () {
    return {
      filters: {
        name: '',
        type: '',
        phase: '',
        intervention: '',
        pds: '',
        region: ''
      }
    }
  },
  methods: {
    onSubmit (event) {
      if (event.isTrusted) {
        this.$store.dispatch('LOAD_CONFIG').then(results => {
          this.$store.dispatch('LOAD_ACTIONS', {filters: this.queryserialize(this.filters), fase: true, config: results})
        })
      }
    },
    cancel (event) {
      if (event.isTrusted) {
        event.preventDefault()
        this.filters = {
          name: '',
          type: '',
          phase: '',
          intervention: '',
          pds: '',
          region: ''
        }
        this.$store.dispatch('CANCEL_ACTIONS')
        this.$store.commit('SET_LOADING', null)
      }
    },
    checkForm (event) {
      for (let filter in this.filters) {
        if (this.filters[filter]) {
          return true
        }
      }
    },
    queryserialize (obj) {
      const str = []
      for (var p in obj) {
        if (obj.hasOwnProperty(p) && obj[p]) {
          if (p === 'name') {
            str.push(`LOWER(Azioni.azione) LIKE LOWER('%${obj[p]}%')`)
          } else if (p === 'intervention') {
            str.push(`TBL_Interventi.intervento = '${obj[p]}'`)
          } else if (p === 'phase') {
            str.push(`Azioni.fase = '${obj[p]}'`)
          } else if (p === 'pds') {
            str.push(`TBL_Interventi.PDS = '${obj[p]}'`)
          } else if (p === 'region') {
            str.push(`TBL_Regioni.nome = '${obj[p]}'`)
          } else if (p === 'type') {
            str.push(`Azioni.tipologia = '${obj[p]}'`)
          }
        }
      }
      return str.join(' AND ')
    }
  },
  mounted () {
    this.$store.dispatch('LOAD_CONFIG')
  }
}
</script>

<style lang='scss' scoped>
.field {
  margin-bottom: 3em;
}
.actions {
  margin-bottom: 0;
}
.label {
  color: #ffffff;
}
.select {
  width: 100%;
  select {
    width: 100%;
  }
}
.button.is-text {
  color: #ffffff;
  text-decoration: none;
  &:hover,
  &:focus {
    background-color: transparent;
    color: #d4d3d3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AdvancedSearch.vue